<template>
	<div class="erji-content pp50">
		<div class="container">
			<div class="erji-title">
				<h1>{{title}}</h1>
				<h2>{{titleEn}}</h2>
			</div>
			<div class="erji-content-div">
				<div class="tx_list">
					<dl>
						<dd v-for="(item,index) in list" :key="index">
							<div class="tx_dd">
								<div class="tx_dd_left fl">
									<!-- {{}} -->
									<!-- <h1><a :href="icoURL+'storage/'+JSON.parse(item.file)[0].download_link" target="_blank"> -->
									<h1><a href="#" target="_blank">
										{{item.title}}.pdf</a>
									</h1>
									<h2>995.9KB</h2>
								</div>
								<div class="tx_dd_right fr">
									<h1>{{item.created_at.slice(0,10)}}</h1>
									<h2>{{item.hit}}</h2>
								</div>
								<div class="clear"></div>
							</div>
						</dd>
					</dl>
				</div>
				<div class="fenye" v-if="list && list.length>0">
					<el-pagination
						background
						layout="prev, pager, next"
						:total="this.pageObj.total"
						:page-size="pageNum"
						prev-text="上一页"
						next-text="下一页"
						:hide-on-single-page='this.pageObj.total < pageNum+1'
						@current-change="pageChange($event)"
						>
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'communication',
		data(){
			return{
				title:'',
				titleEn:'',
				id:'',
				body:'',
				list:[],
				pageNum:4,
				pageObj:[],
				pagee:1
			}
		},
		methods:{
			res_menuClass(){
				this.axios.get('/api/menus/class?id=' + this.id)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.title = response.data.reslut.name;
							this.titleEn = response.data.reslut.sub_title;
						}
						
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			//请求列表
			res_list(e,p){
				this.axios.get("/api/news/listNews?category_id="+this.id+"&limit="+ e +"&page="+p)
					.then(response => {
						// 处理成功情况
						console.log('response',response)
						if(response.data.code == 200){
							// this.list = JSON.parse(response.data.reslut.data);
							this.pageObj = response.data.reslut;
							this.list = response.data.reslut.data
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			pageChange(curPage){
				this.res_list(this.pageNum,curPage)
			},
		},
		created(){
			// console.log('关于我们',this.$route.query.category_id)
			this.id= this.$route.query.category_id
			this.res_menuClass();
			this.res_list(this.pageNum,this.pagee);
		}
	}
</script>

<style>
</style>